<template>
  <section class="page-main" id="pageMainH">
    <input type="password" v-show="false" />
    <el-row class="container" :class="{'is-min': collapsed, 'min-page':ismin}">
      <el-col :span="24" class="main">
        <!--start 导航菜单 :class="{'hide_head':hideHead}"-->
        <div class="top-menu" v-show="$route.meta.isLogin != true" :class="$route.meta.isIndex == true ? 'index page-home' : ''">
          <div class="logo xieconet-logo">
            <a @click="backHome" :class="showLogin ? '' :'center'">
              <img :src="getLogoUrl" />
            </a>
          </div>
          <!--mobile 显示中英文切换按钮-->
          <ul class="mobileLangu" v-if="false">
            <li v-if="thisLang == 'en'">
              <span class="custom-item lan">
                <span
                  class="menu-item"
                  @click="cut_lan('cn')"
                >
                <span class="border-set langu">
                   <i class="iconfont icon-chinese"></i>
                  中文
                </span>
              </span>
              </span>
            </li>
            <li v-if="thisLang == 'cn'">
              <span class="custom-item lan">
                <span
                  class="menu-item"
                  @click="cut_lan('en')"
                >
                  <span class="border-set langu"><i class="iconfont icon-english"></i>English</span>
              </span>
              </span>
            </li>
          </ul>
          <span
            class="mobile-nav-btn"
            @click="showMobileNav"
          >
          <i :class="mobileNav ? 'el-icon-close':'el-icon-menu'"></i>
        </span>
          <div
            class="responsive-nav"
            :class="{'close':mobileNav}"
          >
            <div
              v-if="false"
              class="menu-tab"
            >
              <el-menu
                :default-active="defaultIndex"
                mode="horizontal"
                ref="topNav"
                :class="$route.meta.isIndex == true ? 'index' : ''"
                class="el-menu--dark"
              >
                <el-menu-item
                  :class="$route.meta.isIndex == true ? 'index' : ''"
                  index="search_company"
                  @click="searchRoute(0)"
                >
                  <span
                    class="menu-item"
                    :class="$route.meta.isIndex == true ? 'index' : ''"
                  >{{ $t('SEARCH_CMP') }}</span>
                </el-menu-item>
                <el-menu-item
                  :class="$route.meta.isIndex == true ? 'index' : ''"
                  index="search_person"
                  @click="searchRoute(1)"
                >
                  <span
                    class="menu-item"
                    :class="$route.meta.isIndex == true ? 'index' : ''"
                  >{{ $t('SEARCH_CCT') }}</span>
                </el-menu-item>
                <!--<el-menu-item :class="$route.meta.isIndex == true ? 'index' : ''" index="search_credit" @click="searchRoute(2)">
                  <span class="menu-item" :class="$route.meta.isIndex == true ? 'index' : ''">{{$t('_908BA8F840F48F54')}}</span>
                </el-menu-item>-->
                <el-menu-item
                  @click="checkLogin"
                  :class="$route.meta.isIndex == true  ? 'index' : ''"
                  index="user_company"
                >
                  <span
                    class="menu-item"
                    :class="$route.meta.isIndex == true ? 'index' : ''"
                  >{{ $t('MY_COMPANY_AND_PERSON') }}</span>
                </el-menu-item>
              </el-menu>
            </div>
            <div class="menu-user">
              <ul>
                <!-- 商圈邀请 -->
                <!--<li v-if="!channelId && is_cert">
                <span class="custom-item" @click="$router.push({path:'/member/invitation'})"><span class="menu-item"
                                                                                                   :class="{'index':$route.meta.isIndex == true ? true : false,
                                         'is-active high':$route.meta.menuIndex=='invitation' ? true : false}"
                ><span class="border-set high-light">
                                      <i class="iconfont icon-commercial" style="font-size: 12px;"></i>
                                     {{$t('D062')}}
                                  </span>
                </span>
                </span>
                </li>
                <!-- VIP套餐 -->
                <li v-if="!channelId">
                  <span
                    class="custom-item"
                    @click="$router.push({path:'/package'})"
                  >
                    <span
                      class="menu-item"
                      :class="{'index':$route.meta.isIndex == true ? true : false,
                                           'is-active':$route.meta.menuIndex=='package' ? true : false}"
                    >
                      <span class="border-set high-light">
                        <i
                          class="iconfont icon-huiyuanfuwu"
                          style="font-size: 12px;"
                        ></i>
                        {{$t('_D6D6566556C3D365')}}
                      </span>
                    </span>
                  </span>
                </li>
                <!-- 企业认证 -->
                <li v-if="false && !channelId && !is_cert">
                  <span
                    class="custom-item"
                    @click="$router.push({path:'/member/company-circle'})"
                  >
                    <span
                      class="menu-item"
                      :class="{'index':$route.meta.isIndex == true ? true : false,
                               'is-active high':$route.meta.menuIndex=='company-circle' ? true : false}"
                    >
                      <span class="border-set high-light">
                        <i
                          class="iconfont icon-enterprise-dentify"
                          style="font-size: 12px;"
                        ></i>
                       {{$t('_7F28764B786320F9')}}
                      </span>
                    </span>
                  </span>
                </li>
                <!-- 语言切换 -->
                <!-- <li v-if="thisLang == 'en'">
                  <span class="custom-item lan">
                    <span
                      class="menu-item"
                      @click="cut_lan('cn')"
                    >
                      <span class="border-set langu">
                        <i class="iconfont icon-chinese"></i>
                        中文
                      </span>
                    </span>
                  </span>
                </li>
                <li v-if="thisLang == 'cn'">
                  <span class="custom-item lan">
                    <span
                      class="menu-item"
                      @click="cut_lan('en')"
                    >
                      <span class="border-set langu"><i class="iconfont icon-english"></i>English</span>
                    </span>
                  </span>
                </li> -->
                <!-- 登录注册 -->
                <li
                  v-show="!isLogin && $route.meta.isLogin != true"
                  :style="showLogin ? '' : 'margin-right: 67px;'"
                >
                  <span
                    class="custom-item"
                    @click="login(1)"
                  >
                    <span
                      class="menu-item"
                      :class="$route.meta.isIndex == true ? 'index' : ''"
                    >
                      {{$t('SETTING_LOGIN')}}
                    </span>
                  </span>
                </li>
                <li v-show="!isLogin && $route.meta.isLogin != true && showLogin">
                  <span
                    class="custom-item"
                    @click="login(3,2)"
                  >
                    <span
                      class="menu-item"
                      :class="$route.meta.isIndex == true ? 'index' : ''"
                    >
                      {{$t('SETTING_SIGNUP')}}
                    </span>
                  </span>
                </li>
                <li v-if="isLogin">
                  <div :class="{'user-info': true, 'user-info-light': !$route.meta.isIndex}">
                    <el-dropdown
                      trigger="hover"
                      :hide-timeout="200"
                      :show-timeout="200"
                    >
                      <span
                        class="custom-item el-dropdown-link"
                        style="font-size: 12px;"
                        :class="$route.meta.menuIndex=='member'?'is-active':''"
                      >
                        <i class="iconfont icon-male"></i>
                        <span>
                          {{sysUserName.indexOf('@') != -1 ? sysUserName.split('@')[0] : sysUserName}}
                        </span>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="userDetail" v-if="false">
												<span
                          class="userinfo-inner"
                          style="font-size: 12px;"
                        >
                          <span>
                            <img
                              :src="sysUserAvatar"
                              height="30"
                              width="30"
                            >
                          </span>
												  <span>{{sysUserName}}</span>
												</span>
                        </el-dropdown-item>
                        <!-- 个人中心 -->
                        <el-dropdown-item
                          divided
                          @click.native="$router.push('/member/account')"
                          style="font-size: 12px;"
                        >
                          <i class="fa fa-user-circle pd-lf15"></i>
                          <span class="pd-lf30">{{$t('_8A182451A9CE6F93')}}</span>
                        </el-dropdown-item>
                        <!-- D币中心 -->
                        <el-dropdown-item
                          divided
                          @click.native="$router.push('/member/my-db')"
                          style="font-size: 12px;"
                          v-if="false"
                        >
                          <span class="DB-img"></span>
                          <span class="pd-lf30">{{$t('_CEC257C6291C92B6')}}</span>
                        </el-dropdown-item>
                        <!-- 我的收藏 -->
                        <el-dropdown-item
                          divided
                          @click.native="$router.push('/user_central/person')"
                          style="font-size: 12px;"
                        >
                          <i class="fa fa-heart pd-lf15"></i>
                          <span class="pd-lf30">{{$t('D057')}}</span>
                        </el-dropdown-item>
                        <!-- 退出登录 -->
                        <el-dropdown-item
                          divided
                          @click.native="logout"
                          style="font-size: 12px;"
                        >
                          <i class="fa fa-sign-out pd-lf15"></i>
                          <span class="pd-lf30">{{$t('LOG_OUT')}}</span>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </li>
                <!-- 消息 -->
                <!-- <li class="top-msg-num" @click="$router.push('/member/message')">
                    <img :src="$route.meta.isIndex == true ? require('@/assets/index/if_msg_index.svg') : require('@/assets/index/if_msg.svg') ">
                    <span v-if="unread_msg > 0" :class="{'num-index': footHome}">{{unread_msg | filterNum}}</span> 
              </li>-->
              </ul>
            </div>
          </div>
        </div>
        <!--end 导航菜单-->
      </el-col>
    </el-row>
    <el-row class="page-container">
      <el-col
        :span="24"
        class="main"
      >
        <!--start 页面下侧-->
        <section
          class="content-container"
          :class="this.$route.meta.isPd?'pd':''"
        >
          <div class="grid-content bg-purple-light">
            <el-col
              :span="24"
              class="content-wrapper"
              :class="{bgf: $route.meta.bgcF}"
            >
              <keep-alive>
                <router-view
                  v-if="$route.meta.keepAlive"
                  @change-home-avatar="changeHomeAvatar"
                  @setLogout="setLogout"
                  @loGin="login"
                  :getUserDone="getUserDone"
                  :level="level"
                  :max_level="max_level"
                  :newBindContact="bindContactName"
                  @get-user-info="getUser"
                ></router-view>
              </keep-alive>
              <router-view
                v-if="!$route.meta.keepAlive"
                @change-home-avatar="changeHomeAvatar"
                @setLogout="setLogout"
                @loGin="login"
                :getUserDone="getUserDone"
                :level="level"
                :max_level="max_level"
                :newBindContact="bindContactName"
                :channelColor="channelColor"
                @get-user-info="getUser"
              ></router-view>
              <!-- 意见反馈-->
              <div>
                <Feedback v-if="!huisuanzhangFlag" @loGin="login" />
              </div>
            </el-col>
          </div>
        </section>
        <!--start 页面右侧-->
      </el-col>
    </el-row>
    <div
      class="register-bg custom-register-form"
      v-show="dialogVisible"
    ></div>
    <loginForm
      class="custom-register-form"
      v-show="dialogVisible"
      @closeDialog="dialogVisible = false;"
      :showDialog="true"
      @asycNameType="handleBindChange"
      @get-user-info="getUser"
      :formParams="formParams"
      :dialogTyper="dialogTyper"
      :nameTyper="nameTyper"
      :invitedIdGard="invitedIdGard"
      :isLimitOut="isLimitOut"
      :searchTip="searchTip"
      @synchronousVar="synVar"
    />
    <!-- 页脚  v-if="showFooter && isChannel"  -->
    <footer
      class="page-footer"
      :class="{'page-foot-fixed':footHome}"
      v-if="false"
    >
      <!--渠道用户： 所有页面不展示备案，非首页展示数据由Xieco提供,非渠道用户：首页展示备案， 所有页面不展示数据由Xieco提供-->
      <span v-if="(isChannel || !showLogin) && !footHome">{{$t('D382')}}</span>
      <p v-if="footHome && !isChannel && showLogin">{{$t('D415')}}：service@xieco.net</p>
      <p v-if="footHome && !isChannel && showLogin && isCN">{{$t('_C7286B64327DEBBB')}}</p>
    </footer>
    <footerComp v-if="footHome && !huisuanzhangFlag" @loGin="login"/>
    <el-dialog
      class="index-tip-dialog"
      center
      v-if="showTipFlag"
      :visible.sync="showTipFlag"
      :before-close="handleClose"
      width="600px">
      <span slot="title" class="index-tip-title">{{$t('D481')}}</span>
      <ul class="index-tip">
        <li class="item mag-t-20">{{$t('D483')}}</li>
        <li class="item mg-l-20">{{$t('D484')}}</li>
        <li class="item mg-l-20">{{$t('D485')}}</li>
        <li class="item mg-l-20">{{$t('D486')}}</li>
        <li class="item mag-b-20">{{$t('D487')}}</li>
        <li class="tips">{{$t('D488')}}</li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">{{$t('D489')}}</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import loginForm from '../views/login.vue'
import Feedback from '../views/common/feedback.vue'
import footerComp from '../components/footer'
import * as types from '../store/types'
import {
  getUserInfo,
  getCertification,
  getContactDetail,
  searchContactList,
  lookUpSomeone,
  regEmail,
  unreadCount
} from '../api/api'
import axios from 'axios'
import { mapState, mapMutations } from 'vuex'
import unreadMsgMixin from '@/mixin/unreadMsgMixin'

export default {
  components: {
    loginForm,
    Feedback,
    footerComp
  },
  mixins: [unreadMsgMixin],
  data() {
    return {
      registerEmail: '', // 参数获取邮箱地址
      mobileNav: false, //移动端导航
      footHome: false,
      showFooter: false,
      token: this.$store.state.token,
      defaultIndex: 'search_company',
      collapsed: false,
      sysUserName: '',
      sysUserAvatar: '',
      currentMenu: '',
      clientWidth: 0,
      ismin: false,
      dialogVisible: false,
      getUserDone: false,
      hideHead: false,
      level: -1,
      max_level: 1,
      thisLang: 'cn',
      dialogTyper: 1,
      nameTyper: 1,
      invitedIdGard: '',
      bindContactName: '',
      isLimitOut: false,
      searchTip: '',
      channelId: '',
      logoUrl: '',
      channelColor: '',
      is_cert: true,
      formParams: {
        dialogTyper: 1,
        nameTyper: 1,
        invitedIdGard: '',
        isLimitOut: false,
        searchTip: '',
      },
      showTipFlag: false,
      huisuanzhangFlag: false
    }
  },
  filters: {
    filterNum(num) {
      return num > 99 ? '99+' : num
    }
  },
  computed: {
    ...mapState(['area_id']),
    isLogin() {
      let bool = false
      if (this.$store.state.token) {
        bool = true
      }
      return bool
    },
    //是否渠道用户
    isChannel() {
      return this.$store.state.channel ? true : false
    },
    isCN() {
      return window.sessionStorage.getItem('ip_isCn') === 'true'
    },
    showLogin() {
      var customSettings = window.localStorage.getItem('customSettings')
      var logoUrl = ''
      var channelColor = ''
      if (customSettings) {
        customSettings = JSON.parse(customSettings)
        if (customSettings.logo) {
          return false
        }
      }
      return true
    },
    getLogoUrl() {
      this.logoUrl =
        this.$route.meta.isIndex == true
          ? require('./../assets/logo_white.png')
          : require('./../assets/logo.png')
      //判断是否iframe加载
      this.setCustomerSetting()
      if (top.location != location) {
        this.customSettings()
      }
      return this.logoUrl
    },
  },
  methods: {
    // 限制最小高度
    setMinHeight() {
      this.$nextTick(() => {
        let h =
          document.documentElement.clientHeight || document.body.clientHeight
        if (h > 700) {
          document.querySelector('#pageMainH').style.minHeight = `${h}px`
        } else {
          document.querySelector('#pageMainH').style.minHeight = '700px'
        }
      })
    },
    //移动端导航显示
    showMobileNav() {
      this.mobileNav = !this.mobileNav
    },
    //检查登录
    checkLogin() {
      if (this.isLogin) {
        this.$router.push('/user_central/person')
      } else {
        this.isLimitOut = true
        this.searchTip = this.$t('D337')
        this.dialogVisible = true
        this.$refs.topNav.activeIndex = this.$route.meta.menuIndex
        return false
      }
    },
    //返回首页
    backHome() {
      this.$router.push('/')
    },
    //同步子父组件变量
    synVar(dialogType, nameType) {
      this.dialogTyper = dialogType
      this.nameTyper = nameType
    },
    // 通过子组件同步更改头像地址
    changeHomeAvatar(url, name) {
      this.sysUserAvatar = url
      this.sysUserName = name
    },
    handleBindChange(name) {
      this.bindContactName = name
    },
    searchRoute(type) {
      if (type === 0) {
        let searchCompanyName =
          window.sessionStorage['searchCompanyName' + window.localStorage.user]
        if (searchCompanyName == '' || searchCompanyName == undefined) {
          this.$router.push({
            path: '/',
          })
        } else {
          if (this.area_id === 1) {
            this.$router.push({
              path: '/search/company',
              query: {
                company_name: searchCompanyName,
              },
            })
          } else if (this.area_id === 0) {
            this.$router.push({
              path: '/search/cn-company',
              query: {
                company_name: searchCompanyName,
              },
            })
          }
        }
      } else if (type === 1) {
        let searchName =
          window.sessionStorage['searchName' + window.localStorage.user]
        if (searchName == '' || searchName == undefined) {
          this.$router.push({
            path: '/person',
          })
        } else {
          this.$router.push({
            path: '/search/person',
            query: {
              name: searchName,
            },
          })
        }
      } else if (type === 2) {
        this.$router.push({
          path: '/credit',
        })
      }
    },
    //退出系统
    logout: function() {
      this.$confirm(this.$t('HOME_07'), this.$t('MEMBER_12'), {
        confirmButtonClass: '',
        confirmButtonText: this.$t('HOME_14'),
        cancelButtonText: this.$t('HOME_13'),
        //
      }).then(() => {
        this.axios.get('/api/logout').then(res => {})
        this.$nextTick(() => {
          this.level = -1
          this.clearStore()
          this.$router.push('/')
          this.is_cert = false
        })
      })
    },
    setLogout(value) {
      this.logout()
    },
    login: function(type, nameType, invitedIdGard, isLimitOut, searchTip) {
      this.dialogVisible = true
      this.dialogTyper = type
      this.nameTyper = nameType ? nameType : 2
      // this.invitedIdGard = invitedIdGard ? invitedIdGard : '';
      let invitedId = window.localStorage.getItem('invitedId')
      this.invitedIdGard = invitedId ? invitedId : ''
      this.isLimitOut = isLimitOut != undefined ? isLimitOut : false
      this.searchTip = searchTip != undefined ? searchTip : ''

      this.formParams = {
        dialogTyper: this.dialogTyper,
        nameTyper: this.nameTyper,
        invitedIdGard: this.invitedIdGard,
        isLimitOut: this.isLimitOut,
        searchTip: this.searchTip,
        registerEmail: this.registerEmail,
      }

      //   this.$router.push({path: '/user_central/login'});
      //                this.show_login=true;
    },
    //进入用户中心 修改密码以及 用户信息
    userDetail: function() {
      this.$router.push({
        path: '/member/account',
      })
    },
    //折叠导航栏
    minNav() {
      this.defaultIndex = this.$route.meta.menuIndex
      this.ismin = this.$route.meta.ismin
      this.hideHead = this.$route.meta.hideHead
      this.clientWidth = document.body.clientWidth
      if (this.ismin) {
        this.collapsed = true
      } else {
        this.collapsed = false
      }
    },
    getUser() {
      this.getUserDone = false
      if (!this.$store.state.token) return false
      getUserInfo()
        .then(res => {
          this.getUserDone = true
          let user = res.data.data
          let ret = res.data.ret
          if (ret !== 0) {
            // this.clearStore();
          } else {
            this.$store.commit(types.USER, user._id)
            this.sysUserName = user.nick_name ? user.nick_name : user.user_name
            this.channelId = user.channel_id
            this.$store.commit(types.CHANNEL, this.channelId)
            if (user.meal) {
              this.level = user.meal.level
              this.$store.commit(types.LEVEL, user.meal.level)
            }
            this.over_allow = user.over_allow
            this.sysUserAvatar = user.url
            this.getCert()
            if (window.ga) {
              ga('set', 'userId', user._id)
            }
          }
        })
        .catch(error => {
          //打开网站的时候游客状态token请求失败 删除token
          //this.clearStore();
          this.getUserDone = true
          console.log('发生错误！', error)
        })
    },
    clearStore() {
      this.$store.commit(types.LOGOUT)
      this.$store.commit(types.LEVEL, '-1')
      this.$store.commit(types.USER, '')
      this.$store.commit(types.CHANNEL, '')
      //this.getUserDone = false;
    },
    cut_lan(type) {
      this.$i18n.locale = type
      this.thisLang = type
      //window.localStorage.setItem('language', type)
      this.$store.commit(types.LANGUAGE, type)
    },
    customSettings() {
      if (this.$route.query.is_clear == 1) {
        window.localStorage.removeItem('customSettings')
      }
      let customSettings = window.localStorage.getItem('customSettings')
      if (customSettings) {
        customSettings = JSON.parse(customSettings)
        if (customSettings.logo) {
          this.logoUrl = decodeURIComponent(customSettings.logo)
          this.channelColor = customSettings.color
        }
      }
    },
    //未登录与未认证的企业显示认证企业、已认证显示商圈邀请
    getCert() {
      return // todo
      if (!this.isLogin) {
        this.is_cert = false
        return
      }
      getCertification()
        .then(res => {
          if (res.data.ret == 0) {
            this.is_cert = true
          } else {
            this.is_cert = false
          }
        })
        .catch(function(error) {
          console.log('发生错误！', error)
        })
    },
    setCustomerSetting() {
      this.channelColor = decodeURIComponent(this.$route.query.color)
      let customSettings = {}
      if (this.$route.query.logo != undefined) {
        this.channelLogo = this.$route.query.logo
        if (this.isUrl(this.channelLogo)) {
          customSettings.logo = this.channelLogo
        }
      }
      customSettings.color = this.channelColor
      let lc = location.href
      //如果是dd域名
      if ((lc.indexOf('www.xieco.com') !== -1) && top.location == location
      ) {
        window.localStorage.removeItem('customSettings')
        this.logoUrl =
          this.$route.meta.isIndex == true
            ? require('./../assets/logo_white.png')
            : require('./../assets/logo.png')
        this.channelColor = ''
      }
    },
    handleClose () {
      this.showTipFlag = false
      window.localStorage.setItem('showTipsFlag', 'false')
    }
  },
  watch: {
    $route: {
      handler(val) {
        let footHomePath = ['/', '/person', '/abstract', '/privacy']
        if (footHomePath.includes(val.fullPath)) {
          this.showFooter = false
          this.footHome = true
        } else {
          this.showFooter = true
          this.footHome = false
        }
        this.minNav()
        this.showMobileNav()
      },
    },
    clientWidth: 'minNav',
  },
  //登录生命周期
  mounted() {
    let showTipsFlag = localStorage.getItem('showTipsFlag')
    // this.showTipFlag = showTipsFlag ? JSON.parse(showTipsFlag) : true
    // 重置高度
    this.setMinHeight()
    window.onresize = () => {
      this.setMinHeight()
    }
    var showlogin = this.$utils.getUrlKey('showlogin')
    if (showlogin) {
      this.login(1, 1)
    }
    let footHomePath = ['/abstract', '/privacy']
    this.minNav()
    this.getUser()
    this.getCert()
    this.$store.commit(types.TITLE, 'Logout')
    this.thisLang = window.localStorage.getItem('language')
    if (this.$route.meta.isIndex == true) {
      this.footHome = true
    } else if (footHomePath.includes(this.$route.path)) {
      this.footHome = true
    }

    if (this.$route.query.is_clear == 1) {
      window.localStorage.removeItem('customSettings')
    }
    if (this.isLogin) this.unreadCount()
    this.setCustomerSetting()
    if (this.$route.path === '/' && this.$route.query.register === '1') {
      if (this.$route.query.activationId) {
        regEmail({ activationId: this.$route.query.activationId }).then(res => {
          if (res.data.ret === 0) {
            this.registerEmail = res.data.data
          }
          this.login(3, 2)
        })
      } else {
        this.login(3, 2)
      }
    }
  },
}
</script>
<style lang="less">
@import './../styles/common.less';
.el-dropdown-menu {
  padding-top: 0;
}
.el-dropdown-menu__item.el-dropdown-menu__item--divided {
  min-width: 200px;
  &:first-child {
    border-top: none;
    margin-top: 0;
  }
  .DB-img {
    display: inline-block;
    width: 15px;
    height: 15px;
    margin-left: 8px;
    vertical-align: middle;
    background-image: url('../assets/index/sprit.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}

.el-dropdown-menu__item.el-dropdown-menu__item--divided:hover {
  .DB-img {
    background-image: url('../assets/index/sprit_a.svg');
  }
}

.mobileLangu {
  display: none;
}

.top-msg-num {
  display: flex;
  justify-content: right;
  align-items: center;
  height: 50px;
  position: relative;
  cursor: pointer;
  img {
    width: 18px;
    height: 18px;
    margin: 0 5px;
  }
  span {
    color: #fff!important;
    position: absolute;
    right: -8px;
    top: 8px;
    line-height: 16px;
    padding: 0 5px;
    background-color: red;
    border-radius: 8px;
    font-size: 12px;
  }
}

.content-box {
  /* position: absolute !important;
                           top:50px !important;
                           height: e('calc(100% - 50px)') !important;*/
  position: relative;
  top: 50px;
  .main {
    height: 100%;
    .content-container {
      height: 100%;
      .grid-content {
        height: 100%;
        .content-wrapper {
          height: 100%;
          section {
            height: 100%;
          }
        }
      }
    }
  }
}
.bgf {
  background-color: #fff;
}

.custom-layout {
  padding-right: 16px;
  padding-top: 15px;
  cursor: pointer;
}

.hide_head {
  display: none;
}

.bottom-tip {
  text-align: center;
  width: 100%;
  /*padding-left: 300px;*/
  position: fixed !important;
  bottom: 0;
  z-index: 998;
  background: white;
  .tip-block {
    display: inline-block;
    text-align: left;
    &:first-child {
      margin: 50px 0;
    }
    &:last-child {
      padding-left: 40px;
      position: relative;
      top: 26px;
      h2 {
        img {
          float: left;
          margin-top: 5px;
          margin-right: 9px;
          margin-left: -5px;
        }
        color: #61676e;
        font-size: 22px;
        strong {
          color: #5cb883;
        }
      }
      ul {
        li {
          font-size: 18px;
          color: #61676e;
          margin: 20px 0;
          img {
            float: left;
            margin-top: 1px;
          }
          span {
            margin-left: 15px;
          }
        }
      }
    }
  }
}

.container {
  position: relative;
  /* top: 0px;*/
  bottom: 0;
  width: 100%;
  min-height: 100%;
  overflow: auto;
  .main {
    position: relative;
    .icon {
      font-size: 25px !important;
    }
    .icon-index {
      font-size: 32px !important;
    }
    .menu-collapsed {
      flex: 0 0 60px;
      width: 60px;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      /*  background-color: @dark-color;*/
    }
    .menu-expanded {
      flex: 0 0 230px;
      width: 230px;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      /* background-color: @dark-color;*/
    }
    .el-menu--dark {
      /*   background-color: @dark-color;*/
      &.index {
        background: transparent;
      }
      li {
        padding: 0 5px;
        .menu-item {
          display: inline-block;
          height: 32px;
          line-height: 32px;
          padding: 0 15px;
          color: #5f5f5f;
          font-size: 15px;
          font-weight: bold;
          &.index {
            color: white;
          }
        }
        &.is-active {
          color: @base-color;
          .menu-item {
            // color:@base-color;
            color: #8e95ff;
          }
          /* background: #3f4955;*/
          /* font-weight: bold;*/
        }
      }
    }
    .el-menu--horizontal.el-menu--dark .el-menu-item:hover,
    .el-menu--horizontal.el-menu--dark .el-submenu__title:hover {
      /*background-color: transparent;*/
      span {
        /*background: #3f4955;*/
        color: @base-color;
        color: #8e95ff;
      }
    }
    .content-container {
      position: relative;
      flex: 1;
      /*overflow-y: scroll;*/
      /*padding: 30px 40px;*/
      &.pd {
        padding: 30px 40px;
      }
      .breadcrumb-container {
        //margin-bottom: 15px;
        .title {
          width: 200px;
          float: left;
          color: #475669;
        }
        .breadcrumb-inner {
          float: right;
        }
      }
      .content-wrapper {
        box-sizing: border-box;
      }
    }
    .top-menu {
      width: 100%;
      min-width: 950px;
      height: 50px;
      /* background: #273240;*/
      background: white;
      overflow: hidden;
      position: fixed;
      border-bottom: 1px solid #ebebeb;
      z-index: 500;
      &.index {
        background: transparent;
        color: white;
        border-bottom: none;
      }
      .logo {
        float: left;
        width: 280px;
        height: 50px;
        text-align: left;
        a {
          position: relative;
          display: block;
          width: 100%;
          height: 100%;
          color: #fff;
          text-align: left;
          img {
            height: 30px;
            margin: 7px 0 18px 24px;
          }
          &.center {
            text-align: center;
            img {
              height: 30px;
              margin: 10px auto;
              min-width: 84px;
            }
          }
          i {
            position: absolute;
            top: 16px;
            right: 10px;
            font-size: 24px;
          }
          i:hover {
            color: @active-color;
          }
        }
      }
      .menu-tab {
        float: left;
        .el-menu--horizontal {
          .el-menu-item {
            height: 50px;
            line-height: 50px;
            border-bottom: none;
            background: white;
            /*   &:hover {
                                           border-bottom: none;
                                       }*/
            &.index {
              background: transparent;
            }
          }
          .is-active {
            color: @base-color;
            background: #f8f8f8;
            border-bottom: 3px solid #8e95ff;
          }
        }
      }
      .menu-user {
        height: 50px;
        /*   min-width: 375px;*/
        float: right;
        ul {
          li {
            margin-left: 5px;
            float: left;
            &:last-child {
              margin-right: 25px;
            }
          }
        }
        .user {
          text-align: right;
          padding: 0 15px;
          height: 50px;
          margin-top: 9px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .userinfo {
          width: 100%;
          z-index: 10;
          color: #787e86;
          .userinfo-inner.is-active {
            color: @link-color;
          }
          .userinfo-inner {
            float: left;
            text-align: right;
            display: block;
            min-width: 215px;
            padding: 6px 8px 10px 10px;
            border-top: 1px solid #61676e;
            color: #787e86;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            span {
              display: inline-block;
              width: 36px;
              height: 36px;
              overflow: hidden;
              border-radius: 50%;
              vertical-align: middle;
              margin-right: 10px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          a.userinfo-inner:active,
          a.userinfo-inner:visited {
            color: @link-color;
          }
          .userinfo-inner:hover {
            color: #fff;
            img {
              transform: scale(1.1);
            }
          }
        }
      }
      .sign-out {
        float: right;
        display: block;
        width: 30px;
        padding-top: 13px;
      }
      &.page-home {
        position: relative;
        z-index: 999;
        .high-light {
          border-color: #fff;
          color: #fff;
        }
        .custom-item {
          cursor: pointer;
          &.lan {
            .border-set {
              border-color: #fff;
              color: #fff;
            }
          }
        }
        .user-info {
          cursor: pointer;
          color: #fff;
          .el-dropdown {
            color: #fff;
            cursor: pointer;
          }
        }
        .user-info-light {
          .el-dropdown {
            color: #005CAF;
          }
        }
      }
    }
  }
}

.container.min-page {
  padding-left: 60px;
}

.is-min {
  padding-left: 60px;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
}

.index-sr {
  display: block;
  width: 100%;
}

/*@media (max-width: 1100px) {
                      .menu-user {
                        ul {
                          li:nth-child(3) {
                            display: none;
                          }
                        }
                      }
                    }
                    */

@media (max-width: 1366px) {
  .xieconet-logo {
    width: 9% !important;
    min-width: 180px;
    max-width: 280px;
  }
}

@media (min-width: 1367px) {
  .xieconet-logo {
    width: 10% !important;
    min-width: 218px;
    max-width: 280px;
  }
}

.custom-item {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  &.lan {
    /*  border: 1px solid #EBEBEB;
                              border-radius: 2px;*/
    .border-set {
      i {
        position: absolute;
        left: 5px;
      }
    }
  }
  &.lan {
    &:hover {
      /*  border-color: @base-color;
                                color: @base-color;*/
    }
  }
  .menu-item {
    cursor: pointer;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    padding: 0 8px;
    border-radius: 2px;
    .border-set {
      position: relative;
      padding: 3px 5px;
      border: 1px solid #666;
      color: #666;
      border-radius: 2px;
      &.high-light {
        color: #666;
        border: 1px solid #666;
      }
      &.langu {
        padding-left: 27px;
        border-color: #333;
      }
      &:hover {
        color: @base-color;
        border-color: @base-color;
      }
      .icon-commercial {
        font-size: 12px;
        margin-right: 2px;
      }
    }

    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    &.index {
      color: white;
    }
    &:hover {
      color: @base-color;
    }
    &.is-active {
      color: @base-color;
      .high-light {
        border-color: @base-color;
        color: @base-color;
      }
      /* font-weight: bold;*/
    }
  }
}

.userinfo-inner {
  img {
    height: 30px;
    width: 30px;
    border-radius: 3px;
    margin-top: 3px;
    float: left;
    margin-right: 15px;
  }
}

/*.el-dropdown-link{
                            color:white;
                            cursor:pointer;
                            display: inline-block;
                            height: 32px;
                            line-height: 32px;
                            padding: 0 15px;
                            border-radius: 2px;
                            &.is-active{
                                background: #3f4955;
                                !*font-weight: bold;*!
                            }
                        }*/

.pd-lf15 {
  margin-left: 11px;
}

.pd-lf30 {
  margin-left: 15px;
}

.page-main {
  position: relative;
  width: 100%;
  min-height: 750px;
  .page-container {
    position: relative;
    top: 0;
    width: 100%;
    padding-top: 50px;
  }
  .page-footer {
    padding: 40px 0;
    width: 100%;
    clear: both;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    &.page-foot-fixed {
      position: relative;
      bottom: 0;
      color: #fff;
    }
    span {
      font-size: 12px;
      display: inline-block;
      margin: 0 auto;
      padding: 0 15px;
      position: relative;
      &::before {
        position: absolute;
        content: '';
        top: 50%;
        left: -30px;
        width: 30px;
        height: 1px;
        background-color: #ccc;
      }
      &::after {
        position: absolute;
        content: '';
        top: 50%;
        right: -30px;
        width: 30px;
        height: 1px;
        background-color: #ccc;
      }
    }
  }
}

.mobile-nav-btn {
  display: none;
}

@media screen and (max-width: @mobile) {
  .container .main .top-menu {
    min-width: 100%;
    overflow: visible;
  }

  .mobileLangu {
    display: block;
    float: right;
    margin-right: 30px;
  }

  .mobile-nav-btn {
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
    z-index: 1000;
    font-size: 16px;
    padding: 15px;
  }

  .responsive-nav {
    width: 100%;
    position: fixed;
    height: 0;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 100;
    transition: all 0.3s;
    &.close {
      padding-top: 30px;
      height: 100%;
      transition: all 0.3s;
    }
    .el-menu--horizontal {
      border: none;
      .el-menu-item {
        background-color: transparent;
      }
    }
    .menu-user,
    .menu-tab {
      width: 100%;
      padding: 0 30px;
      border: none;
      .el-menu {
        background-color: transparent;
      }
      li {
        width: 100%;
        .user-info,
        .menu-item {
          padding: 0 30px;
        }
      }
    }
  }
}

@media (max-height: 875px) {
  .page-main .page-footer.page-foot-fixed {
    padding: 20px 0 5px;
    position: relative;
  }
}
.index-tip-dialog {
  .el-dialog__header {
    padding-top: 30px;
  }
  .el-dialog__body {
    padding: 20px 50px;
  }
  .index-tip-title {
    font-size: 22px;
    font-weight: bold;
    color: #333;
  }
  .index-tip {
    .title {
      font-size: 20px;
      font-weight: bold;
    }
    .item {
      line-height: 24px;
      &.mg-l-20 {
        margin-left: 10px;
      }
      &.mag-t-20 {
        margin-top: 10px;
      }
      &.mag-b-20 {
        margin-bottom: 20px;
      }
    }
    .tips {
      color: red;
      font-size: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// home.vue?646676ef